import React from 'react';
import { Trans } from 'react-i18next';

const NoAccessTitle = () => (
    <Trans>You do not have permission to access this page</Trans>
)

export default NoAccessTitle